export enum ControlTypes {
  dateTime = 'DateTime',
}
